
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from '@/components/ui/use-toast';

interface LinkedinAnalysisTabProps {
  onSubmit: (text: string, type: 'linkedin') => void;
}

const LinkedinAnalysisTab: React.FC<LinkedinAnalysisTabProps> = ({ onSubmit }) => {
  const [linkedinText, setLinkedinText] = useState('');

  const handleSubmit = () => {
    if (linkedinText.trim()) {
      onSubmit(linkedinText, 'linkedin');
      setLinkedinText('');
    } else {
      toast({
        title: "Empty LinkedIn Profile",
        description: "Please paste your LinkedIn profile text before submitting.",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="space-y-3 h-full flex flex-col pt-0">
      <h3 className="text-lg font-medium">LinkedIn Profile Analysis</h3>
      <p className="text-sm text-muted-foreground">
        Paste your LinkedIn profile text below for personalized feedback, profile optimization tips, and career path recommendations.
      </p>
      <Textarea 
        className="flex-1 min-h-[200px]"
        placeholder="Paste your LinkedIn profile text here..."
        value={linkedinText}
        onChange={(e) => setLinkedinText(e.target.value)}
      />
      <Button onClick={handleSubmit} className="ml-auto">
        Analyze LinkedIn Profile
      </Button>
    </div>
  );
};

export default LinkedinAnalysisTab;
